import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="disable-blank-password"
export default class extends Controller {
  static targets = ["password"];
  connect() {}

  disable(event) {
    const field = this.hasPasswordTarget ? this.passwordTarget : null;
    if (field && !field.value) field.disabled = true;
  }
}
